import { render, staticRenderFns } from "./InvoicePaymentResult.vue?vue&type=template&id=6f659dbd&scoped=true&"
import script from "./InvoicePaymentResult.vue?vue&type=script&lang=js&"
export * from "./InvoicePaymentResult.vue?vue&type=script&lang=js&"
import style0 from "./InvoicePaymentResult.vue?vue&type=style&index=0&id=6f659dbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f659dbd",
  null
  
)

export default component.exports